import { inject } from 'vue'
import { isDefined } from '@vueuse/core'
import { PendoInjectionKey } from '@/tracking/PendoPlugin'

export interface PendoVisitor {
  id?: string
  email?: string
  firstName?: string
  lastName?: string
  userPermissions?: string
  role?: string
  department?: string
  paidOrTrialUser?: string | boolean
}

export interface PendoAccount {
  id?: string
  accountName?: string
  payingStatus?: string
  accountValue?: string | number
  businessTier?: string
  industry?: string
  marketSegment?: string
  accountCreationDate?: string | Date
  contractStartDate?: string | Date
  renewalDate?: string | Date
  planPrice?: string | number
  accountManager?: string
  location?: string
}

export interface PendoOptions {
  visitor?: PendoVisitor
  account?: PendoAccount
  excludeAllText?: boolean
}

export type Pendo = {
  initialize: (options: PendoOptions) => void
}

export function usePendo(): Pendo {
  const pendoClient = inject<Pendo>(PendoInjectionKey)
  if (!isDefined(pendoClient)) {
    throw new Error('Pendo client could not be determined')
  }
  return pendoClient
}
